export interface IDefaultFilter {
  filters: [] | { fieldname: string; search?: string; sort?: number }[];
  globalSearch: string;
  page: number;
  limit: number;
}

export type QueryParams = {
  orderBy: string;
  page: number;
  rowsPerPage: number;
  globalSearch: string;
  fieldSearch: Record<string, string>;
  order: string;
  dateTimeFiltre?: any;
};

export const defaultFilter = {
  filters: [{ fieldname: 'createdAt', sort: 1 }],
  globalSearch: '',
  page: 1,
  limit: 10,
};

export type ITenant = {
  id: string;
  name: string;
  regNumber: string;
  email: string;
  supportEmail?: string | null;
  ProfileURL: null | string;
  status: string | null;
  createdAt: string;
  updatedAt: string;
  businessIndustry: string | null;
  companySize: string | null;
  limits: any;
  tenantLimits?: any;
};

/** Buyer details sent to Odoo on every invoice (`/api/tenants/billing-profile`). */
export type IBillingProfile = {
  id: string;
  tenantId: string;
  /** Arabic company name; sent to Odoo as the customer name. */
  name: string | null;
  nameEn: string | null;
  mobile: string | null;
  isCompany: boolean;
  vatNumber: string | null;
  street: string | null;
  neighborhood: string | null;
  city: string | null;
  zip: string | null;
  buildingNumber: string | null;
  plotIdentification: string | null;
  countryCode: string | null;
  stateCode: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
};

export type IBillingProfileInput = Partial<
  Omit<IBillingProfile, 'id' | 'tenantId' | 'metadata' | 'createdAt' | 'updatedAt'>
>;

export const defaultTenant = {
  id: '',
  name: '',
  regNumber: '',
  email: '',
  ProfileURL: '',
  status: '',
  createdAt: '',
  updatedAt: '',
  businessIndustry: null,
  companySize: null,
  limits: null,
};
